import { render, staticRenderFns } from "./check-detail-dialog.vue?vue&type=template&id=155bbbe2&scoped=true"
import script from "./check-detail-dialog.vue?vue&type=script&lang=ts"
export * from "./check-detail-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155bbbe2",
  null
  
)

export default component.exports